import actionTypes from './actionTypes';
import { getAllServices } from '../../sources/service';
import { addNotification } from './notification';

const fetchAllServices = authenticationToken => async (dispatch) => {

    let allServices;

    try {
        allServices = await getAllServices({ token: authenticationToken })
    } catch (e) {
        return dispatch(addNotification({
            type: 'error',
            message: 'Cannot retrieve all services',
        }));
    }

    return dispatch({
        type: actionTypes.SERVICES_SET_ALL,
        payload: allServices,
    });
};

export default fetchAllServices;
